<template>
  <div id="trace-crop">
    <img class="crop-img" :src="getPlantMessage.picture" />
    <ul class="crop-message">
      <li class="crop-item crop-item-name">
        <div class="crop-item-label">名称</div>
        <div class="crop-item-value crop-item-value-name">{{ getPlantMessage.name }}</div>
      </li>
      <li class="crop-item crop-item-type">
        <div class="crop-item-label">品种</div>
        <div class="crop-item-value">{{ getPlantMessage.category }}</div>
      </li>
      <li class="crop-item">
        <div class="crop-item-label">规模</div>
        <div class="crop-item-value crop-item-value-scale">{{ getPlantMessage.scale }}</div>
      </li>
      <li class="crop-item">
        <div class="crop-item-label">种植日期</div>
        <div class="crop-item-value">{{ getPlantMessage.startTime }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "trace-crop",
  data() {
    return {};
	},
	computed: {
		...mapGetters("trace", ["getPlantMessage"])
	}
};
</script>

<style scoped>
ul {
  list-style: none;
}

#trace-crop {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.crop-img {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 100%;
  max-height: 100%;
}

.crop-message {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  z-index: 3;
}

.crop-item {
  display: flex;
  align-items: center;
  width: 50%;
  height: 1.6vw;
}

.crop-item-name {
  margin-bottom: 0.2vw;
}

.crop-item-type {
  margin-bottom: 0.2vw;
}

.crop-item-label {
  width: 3.6vw;
  height: 100%;
  background-color: rgba(0, 56, 100, 0.9);
  color: #FFFFFF;
  font-size: 0.6vw;
  line-height: 1.6vw;
  text-align: center;
  margin-right: 0.2vw;
}

.crop-item-value {
  width: calc(100% - 3.8vw);
  height: 100%;
  line-height: 1.6vw;
  padding-left: 0.4vw;
  background-color: rgba(0, 24, 42, 0.9);
  font-size: 0.6vw;
  color: #a7a7a7;
}

.crop-item-value-name {
  margin-right: 0.2vw;
}

.crop-item-value-scale {
  margin-right: 0.2vw;
}
</style>
